var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.2129,
    cy: 21.2136,
    r: 15,
    transform: "rotate(-135 21.2129 21.2136)",
    fill: "#999999"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1599 15.6601C16.5504 15.2696 17.1836 15.2696 17.5741 15.6601L21.2217 19.3078L24.8605 15.669C25.2511 15.2784 25.8842 15.2784 26.2747 15.669L26.7576 16.1519C27.1482 16.5424 27.1482 17.1756 26.7576 17.5661L23.1188 21.2049L26.7665 24.8525C27.157 25.243 27.157 25.8762 26.7665 26.2667L26.2659 26.7673C25.8754 27.1578 25.2422 27.1578 24.8517 26.7673L21.2041 23.1197L17.5653 26.7585C17.1747 27.149 16.5416 27.149 16.151 26.7585L15.6681 26.2756C15.2776 25.885 15.2776 25.2519 15.6681 24.8613L19.3069 21.2225L15.6593 17.5749C15.2688 17.1844 15.2688 16.5512 15.6593 16.1607L16.1599 15.6601Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.61adee172c942d9a8383296110e846e9.svg";
export { ForwardRef as ReactComponent };